import React from 'react';
const Logout = () => {

    localStorage.clear();
    window.location.replace(process.env.REACT_APP_BASE_URL);
    return <div></div>;
}

export default Logout;